"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchoolModel = void 0;
var Model_1 = __importDefault(require("../Model"));
var SchoolModel = /** @class */ (function (_super) {
    __extends(SchoolModel, _super);
    function SchoolModel(school, getters) {
        var _this = _super.call(this, getters) || this;
        _this.id = school.id;
        _this.name = school.name;
        _this.localization = school.localization;
        _this.administrativeDependency = school.administrativeDependency;
        _this.cityId = school.cityByCityId || school.cityId;
        return _this;
    }
    Object.defineProperty(SchoolModel.prototype, "city", {
        get: function () {
            return this.getters.cityById(this.cityId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SchoolModel.prototype, "nameWithLocation", {
        get: function () {
            return this.name + " \u2022 " + this.city.fullName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SchoolModel.prototype, "lists", {
        get: function () {
            return this.getters.listsBySchoolId(this.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SchoolModel.prototype, "classes", {
        get: function () {
            var classNames = this.lists
                .filter(function (list) { return list.metadata; })
                .map(function (list) { return list.metadata.class + " \u2022 " + list.metadata.grade; });
            return __spread(new Set(classNames));
        },
        enumerable: false,
        configurable: true
    });
    return SchoolModel;
}(Model_1.default));
exports.SchoolModel = SchoolModel;
